import { render, staticRenderFns } from "./createTRWorkFileMain.vue?vue&type=template&id=24846af6&"
import script from "./createTRWorkFileMain.vue?vue&type=script&lang=js&"
export * from "./createTRWorkFileMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports